import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import moment from 'moment'
import { range, each, map, clone, cloneDeep, find } from 'lodash'
import $ from 'jquery'; 

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import HelpAlert from '../components/HelpAlert'
import DataTable from '../components/DataTable'

import { Line } from 'react-chartjs-2';
import { Select, Row, Col, Spin, message } from 'antd'
const { Option } = Select


class Report5 extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        year: moment().year(),
        data: null,
        loading: false
    }

    fetch = () => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'reports/5/' + this.state.year 
        }).then((data) => {
            each(data.byLaboratory, laboratory => {
                laboratory.name = comboboxes.byKey["laboratory"][laboratory.laboratory].value
            })
            this.setState({
                data: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate() {
        const { loading, data, year } = this.state
        if (!loading && data) {
            const total = find(data.byYear, { year: "" + year })
            if (total) {
                let tfoot = '<tfoot class="ant-table-thead"><tr><th>Total</th>'
                each(moment.months(), (month, index) => (
                    tfoot += '<th>' + (total.items[index + 1] || 0) + '</th>'
                ))
                tfoot += "<th>" + total.total + "</th></tr></tfoot>"
                $(".table-laboratories table").append(tfoot)
            }
        }
    }

    onChangeYear = (value) => {
        this.setState({ year: value }, this.fetch)
    }

    render() {
        const { loading, data, year } = this.state
        const { intl } = this.props

        if (loading || !data) {
            return <Spin />
        }

        /**
         * Default chart values
         */
        const chartColors = ['rgb(201, 203, 207)', 'rgb(153, 102, 255)', 'rgb(54, 162, 235)', 'rgb(75, 192, 192)', 'rgb(255, 205, 86)', 'rgb(255, 159, 64)' , 'rgb(255, 99, 132)'];
        var chartConfig = {
            responsive: true,
            title:{
                display: true,
                text: 'Title'
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'X label'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Y label'
                    }
                }]
            }
        };

        /**
         * Chart 1
         */
        const chart1Colors = clone(chartColors)
        const chart1Data = {
            labels: moment.monthsShort(),
            datasets: map(data.byLaboratory, laboratory => {
                const color = chart1Colors.pop() || '#' + Math.floor(Math.random() * 16777215).toString(16)
                return {
                    label: this.props.comboboxes.byKey["laboratory"][laboratory.laboratory].value,
                    fill: false,
                    backgroundColor: color,
                    borderColor: color,
                    data: map(moment.monthsShort(), (month, index) => laboratory.items[index + 1] || 0)
                }
            })
        }
        const chart1Config = cloneDeep(chartConfig)
        chart1Config.title.text = intl.formatMessage({id: 'reports.report5.chart1.title'})
        chart1Config.scales.xAxes[0].scaleLabel.labelString = intl.formatMessage({id: 'reports.report5.chart1.xAxes'})
        chart1Config.scales.yAxes[0].scaleLabel.labelString = intl.formatMessage({id: 'reports.report5.chart1.yAxes'})

        /**
         * Chart 2
         */
        const chart2Colors = clone(chartColors)
        const chart2Data = {
            labels: moment.monthsShort(),
            datasets: map(data.byYear, year => {
                const color = chart2Colors.pop() || '#' + Math.floor(Math.random() * 16777215).toString(16)
                return {
                    label: year.year,
                    fill: false,
                    backgroundColor: color,
                    borderColor: color,
                    data: map(moment.monthsShort(), (month, index) => year.items[index + 1] || 0)
                }
            })
        }
        const chart2Config = cloneDeep(chartConfig)
        chart2Config.title.text = intl.formatMessage({id: 'reports.report5.chart2.title'})
        chart2Config.scales.xAxes[0].scaleLabel.labelString = intl.formatMessage({id: 'reports.report5.chart2.xAxes'})
        chart2Config.scales.yAxes[0].scaleLabel.labelString = intl.formatMessage({id: 'reports.report5.chart2.yAxes'})

        /**
         * Table
         */
        const columns = [
            { title: "reports.report5.laboratory", dataIndex: "name", type: "string", sorter: true },
        ]
        each(moment.months(), (month, index) => (
            columns.push({ title: month, formatTitle: false, key: month, type: "number", dataIndex: "items[" + (index + 1) + "]", sorter: true })
        ))
        columns.push({ title: "reports.report5.total", type: "number", dataIndex: "total", sorter: true })

        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedHTMLMessage id="reports.report5.title" /></h1>
                <div className="action-bar">
                    <Select defaultValue={year} style={{ width: 120 }} onChange={this.onChangeYear}>
                        { range(2016, moment().year() + 1).map(year => <Option key={year} value={year}>{year}</Option>) }
                    </Select>
                </div>
                <HelpAlert style={{ marginTop: '25px', marginBottom: '25px' }} message="reports.report5.helpAlert" />
                <Row gutter={24}>
                    <Col xl={12}><Line data={chart1Data} options={chart1Config} /></Col>
                    <Col xl={12}><Line data={chart2Data} options={chart2Config} /></Col>
                </Row>
                <br />
                <br />
                <DataTable columns={columns} dataSource={data.byLaboratory} rowKey="laboratory" size="middle" className={"table-laboratories"} export />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps)(Report5))


// WEBPACK FOOTER //
// ./src/views/Report5.js